import React, { useState, useEffect } from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import {
  TextField,
  Button,
  Autocomplete,
  IconButton,
  Pagination,
  Modal,
  Box,
  Stack,
  useMediaQuery,
} from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Close } from '@mui/icons-material';
import MapIcon from '@mui/icons-material/Map';
import { create } from '@mui/material/styles/createTransitions';

import { columns } from '../columns/cardEventsForAEmployees';
import service from '../service/employeeResource';
import { useDashboardStore } from '../store/store';

import { format, set } from 'date-fns';
import { useDebounce } from 'use-debounce';
import { ColumnFactory, Excel } from './excel';
//import ExcelJS from 'exceljs';
//import { saveAs } from 'file-saver';

const oneDayInMillis = 24 * 60 * 60 * 1000;
const initialValue = {
  t0: new Date(new Date().getTime() - oneDayInMillis).getTime(),
  t1: Date.now(),
};
const EmployeeModal = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {
    employees,
    employeesLoading,
    cardsOfEmployeeLoading,
    fetchEmployees,
    employeesModal,
    cardsOfEmployee,
    allCardsOfEmployee,
    cardsOfEmployeePage,
    setCardsOfEmployeePage,
    cardsOfEmployeeSortModel,
    cardsOfEmployeePageCount,
    setCardsOfEmployeeSortModel,
    fetchCardsByEmployee,
    resetAllLayerExceptOne,
    resetEmployees,
    resetCardsOfEmployee,
    setCenter,
    fetchAllCardsByEmployee,
  } = useDashboardStore();
  const initialState = {
    t0: initialValue.t0,
    t1: initialValue.t1,
    employeeId: '',
  };
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [debouncedValue] = useDebounce(employeeSearch, 1000);
  useEffect(() => {
    fetchEmployees(debouncedValue);
  }, [debouncedValue]);
  const isMobile = useMediaQuery('(max-width:1024px)');
  const [formState, dispatch] = React.useReducer((state, action) => {
    switch (action.type) {
      case 'CHANGE_FIELD':
        return { ...state, employeeId: action.value };
      case 'CHANGE_DATE':
        return {
          ...state,
          [action.field]: action.value,
        };
      default:
        return state;
    }
  }, initialState);
  function paginationChange(_, e_page) {
    setCardsOfEmployeePage(e_page - 1);
  }
  useEffect(() => {
    resetCardsOfEmployee();
  }, [formState.t0, formState.t1]);
  const createExcel = () => {
    const columns = new ColumnFactory()
      .addColumnsFromPredefined('status')
      .addColumnsFromPredefined('cardId')
      .addColumnsFromPredefined('transportation')
      .addColumnsFromPredefined('time')
      .getColumns();
    const prepareRow = (row) => {
      const { id, status, card, employee, time, transportation } = row;
      return {
        status: `${status}`,
        cardId: `${card?.id || '-'}`,
        transportation: `${transportation?.transportation?.content || '-'}`,
        employeId: `${employee?.id || '-'} ${employee?.user?.firstname || ''} ${
          employee?.user?.lastname || ''
        }`,
        time: `${new Date(time).toLocaleString('tr')}`,
      };
    };
    return new Excel(
      columns,
      allCardsOfEmployee,
      prepareRow,
      'Kart Raporu',
    ).createExcel();
  };
  // Fadimana en sevdiğim canım arkadaşım :)
  useEffect(() => {
    if (formState.employeeId === '') {
      return;
    }
    fetchCardsByEmployee({ ...formState, isMobile });
  }, [cardsOfEmployeePage, cardsOfEmployeeSortModel]);

  useEffect(() => {
    const column = {
      field: 'actions',
      headerName: 'Göster',
      type: 'actions',
      width: 100,
      notFilter: true,
      getActions: (params) => [
        <GridActionsCellItem
          key={params.row.id}
          icon={<MapIcon></MapIcon>}
          label="Haritada Göster"
          onClick={() => {
            resetAllLayerExceptOne('LCards', [params.row]);
          }}
        ></GridActionsCellItem>,
      ],
    };
    columns.push(column);
    return () => {
      columns.pop();
    };
  }, []);

  return (
    <div
      className={`${
        employeesModal ? '' : 'hidden'
      } size-30 absolute top-40 left-5 p-3 rounded-xl bg-white w-72  z-30 `}
    >
      <div>
        <Stack spacing={2}>
          <Autocomplete
            loading={employeesLoading}
            noOptionsText={
              employeeSearch === ''
                ? 'Bir karakter giriniz.'
                : formState.employeeId !== ''
                  ? formState.employeeId
                  : 'Sonuç bulunamadı.'
            }
            loadingText={'Yükleniyor...'}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={employees || []}
            getOptionLabel={(option) =>
              `${
                option?.id +
                  ' ' +
                  option?.user?.firstname +
                  ' ' +
                  option?.user?.lastname || ''
              }`
            }
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                placeholder="Personel Sicil | Ad | Soyad"
                label="Personel Sicil | Ad | Soyad"
                onChange={(e) => {
                  setEmployeeSearch(() => {
                    return e.target.value;
                  });
                }}
              />
            )}
            onChange={(event, newValue) => {
              resetCardsOfEmployee();
              dispatch({ type: 'CHANGE_FIELD', value: newValue?.id });
            }}
          />

          <DateTimePicker
            label="Başlangıç Tarihi"
            ampm={false}
            inputFormat="dd/MM/yyyy hh:mm"
            value={formState.t0}
            onChange={(e) =>
              dispatch({ type: 'CHANGE_DATE', field: 't0', value: e })
            }
            slotProps={{ textField: { size: 'small' } }}
            maxDateTime={formState.t1}
          />
          <DateTimePicker
            label="Bitiş Tarihi"
            ampm={false}
            inputFormat="dd/MM/yyyy hh:mm"
            value={formState.t1}
            onChange={(e) =>
              dispatch({ type: 'CHANGE_DATE', field: 't1', value: e })
            }
            slotProps={{ textField: { size: 'small' } }}
            minDateTime={formState.t0}
            maxDateTime={Date.now()}
          />

          <Button
            variant="contained"
            onClick={() => {
              fetchCardsByEmployee({ ...formState, isMobile });
              fetchAllCardsByEmployee(formState);
            }}
          >
            Ara
          </Button>
          {cardsOfEmployee.length !== 0 && (
            <div className="w-full h-10 border-1 flex flex-col">
              <div className="flex flex-row items-center justify-between"></div>
              <button
                onClick={() => {
                  handleOpen();
                }}
              >
                Kart Raporlarını Göster
              </button>
            </div>
          )}
        </Stack>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            style={{
              outline: 'none',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              height: isMobile ? '500px' : '',
              width: isMobile ? '90%' : '902px',
              backgroundColor: 'white',
              boxShadow: 24,
              paddingY: 2,
              paddingx: 1,
              borderRadius: 5,
            }}
          >
            <div className="flex w-full justify-between flex-col px-2">
              <div className="flex flex-end justify-end w-full">
                <IconButton component="span" onClick={() => handleClose(false)}>
                  <Close />
                </IconButton>
              </div>
              <div className="flex flex-row w-full items-center justify-between">
                <div className="flex flex-col">
                  <h1 className="text-lg font-semibold">
                    {format(new Date(formState.t0), 'dd/MM/yyyy HH:mm')} -{' '}
                    {format(new Date(formState.t1), 'dd/MM/yyyy HH:mm')} arası{' '}
                    {cardsOfEmployee[0]?.employee?.id} |{' '}
                    {cardsOfEmployee[0]?.employee?.user?.firstname}{' '}
                    {cardsOfEmployee[0]?.employee?.user?.lastname} | Kart Raporu
                  </h1>
                  <h2 className="text-sm">
                    Kart id: {cardsOfEmployee[0]?.card?.id} {'|   '}
                    kart okutma sayısı: {allCardsOfEmployee?.length}
                  </h2>
                </div>
                <div>
                  <div className="flex justify-end items-center gap-2 w-[200px] flex-col py-2 px-1">
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: '#2e3448',
                        width: '100%',
                      }}
                      onClick={() => {
                        createExcel();
                      }}
                    >
                      Dışa Aktar
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: '#2e3448',
                        width: '100%',
                      }}
                      onClick={() => {
                        resetAllLayerExceptOne('LCards', allCardsOfEmployee);
                      }}
                    >
                      TüMÜnü HARİTADA GÖSTER
                    </Button>
                  </div>
                </div>
              </div>
              <DataGrid
                rows={cardsOfEmployee}
                columns={columns}
                loading={cardsOfEmployeeLoading}
                autoHeight
                hideFooter
                rowHeight={35}
                showColumnRightBorder
                disableColumnMenu
                sortModel={cardsOfEmployeeSortModel}
                onSortModelChange={(sortModel) =>
                  setCardsOfEmployeeSortModel(sortModel)
                }
              />
              <div className=" flex justify-center items-center my-1">
                <Pagination
                  page={cardsOfEmployeePage + 1}
                  onChange={paginationChange}
                  count={cardsOfEmployeePageCount}
                  color="primary"
                  size="small"
                />
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
};

export default EmployeeModal;
